import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { RowWrapper } from './styled';
import { InPersonMunicipalityQueueTask } from './types';

interface Proptypes {
  reportData: InPersonMunicipalityQueueTask;
}

export const TaskRow = (props: Proptypes) => {
  return (
    <Link to={`/nj-in-person-municipality-form/${props.reportData.id}`}>
      <RowWrapper style={{ cursor: 'pointer' }}>
        <div></div>
        <div>
          <Link to={`/orders/order-information/${props.reportData.orderId}/${props.reportData.propertyId}`}>
            <div style={{ display: 'flex', gap: 4 }}>{`HDS-${props.reportData.orderId}`}</div>
          </Link>
        </div>

        <div>{props.reportData.municipality}</div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <div>{props.reportData.address}</div>
        </div>
        <div>
          {`${props.reportData.block}-${props.reportData.lot}`}
          {`${props.reportData.qualifier ? '-' + props.reportData.qualifier : ''}`}
        </div>
        <div>{moment(props.reportData.dateAdded).format('MM/DD/YYYY')}</div>
      </RowWrapper>
    </Link>
  );
};
